import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function Datenschutz() {
  return (
    <div className="pt-32 pb-24" data-testid="datenschutz-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center gap-2 text-sm mb-8">
          <Link to="/" className="text-[#c8c6c4] hover:text-[#d1af6a]">Home</Link>
          <ChevronRight className="w-4 h-4 text-[#c8c6c4]" />
          <span className="text-[#d1af6a]">Datenschutz</span>
        </nav>

        <h1 className="font-display text-4xl text-white mb-8">Datenschutzerklärung</h1>

        <div className="prose prose-invert prose-p:text-[#c8c6c4] prose-headings:text-white prose-headings:font-subheading prose-li:text-[#c8c6c4] max-w-none space-y-8">

          {/* 1 */}
          <section>
            <h2>1. Datenschutz auf einen Blick</h2>
            <h3>Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche
              Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
              Datenschutzerklärung.
            </p>

            <h3>Datenerfassung auf dieser Website</h3>
            <h4>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
            <p>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
              Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser
              Datenschutzerklärung entnehmen.
            </p>

            <h4>Wie erfassen wir Ihre Daten?</h4>
            <p>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann
              es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p>
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website
              durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B.
              Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser
              Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>

            <h4>Wofür nutzen wir Ihre Daten?</h4>
            <p>
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu
              gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
              Sofern über die Website Verträge geschlossen oder angebahnt werden können, werden die
              übermittelten Daten auch für Vertragsangebote, Bestellungen oder sonstige
              Auftragsanfragen verarbeitet.
            </p>

            <h4>Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
            <p>
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und
              Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein
              Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine
              Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung
              jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten
              Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
            <p>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.</p>
          </section>

          {/* 2 */}
          <section>
            <h2>2. Hosting</h2>
            <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>

            <h3>IONOS</h3>
            <p>
              Anbieter ist die IONOS SE, Elgendorfer Str. 57, 56410 Montabaur (nachfolgend IONOS).
              Wenn Sie unsere Website besuchen, erfasst IONOS verschiedene Logfiles inklusive Ihrer
              IP-Adressen. Details entnehmen Sie der Datenschutzerklärung von IONOS:{' '}
              <a href="https://www.ionos.de/terms-gtc/terms-privacy" target="_blank" rel="noopener noreferrer">
                https://www.ionos.de/terms-gtc/terms-privacy
              </a>.
            </p>
            <p>
              Die Verwendung von IONOS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir
              haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer
              Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
              Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
              Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
            </p>
            <h4>Auftragsverarbeitung</h4>
            <p>
              Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten
              Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich
              vorgeschriebenen Vertrag, der gewährleistet, dass dieser die personenbezogenen Daten
              unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO
              verarbeitet.
            </p>

            <h3>MongoDB Atlas</h3>
            <p>
              Zur Speicherung von Website-Daten (Immobilienobjekte, Kontaktanfragen) nutzen wir
              MongoDB Atlas, einen Datenbankdienst der MongoDB, Inc., 1633 Broadway, 38th Floor,
              New York, NY 10019, USA. Der von uns genutzte Datenbankcluster ist im Rechenzentrum
              Frankfurt am Main (EU) gehostet, sodass keine Datenübertragung in Drittländer
              stattfindet. Mit MongoDB wurde ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO
              abgeschlossen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
              am Betrieb der Website).
            </p>

            <h3>Cloudinary</h3>
            <p>
              Für die Speicherung und Auslieferung von Bildern (insbesondere Immobilienfotos) nutzen
              wir Cloudinary, einen Dienst der Cloudinary Ltd., 30 Old Bailey, London, EC4M 7AU, 
              Großbritannien. Beim Laden von Bildern stellt Ihr Browser eine
              Verbindung zu den Servern von Cloudinary her, wobei Ihre IP-Adresse übermittelt wird.
              Die Server von Cloudinary befinden sich teilweise außerhalb der EU. Mit Cloudinary
              wurde ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO abgeschlossen.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am Betrieb
              der Website). Weitere Informationen:{' '}
              <a href="https://cloudinary.com/privacy" target="_blank" rel="noopener noreferrer">
                https://cloudinary.com/privacy
              </a>
            </p>
          </section>

          {/* 3 */}
          <section>
            <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>

            <h3>Hinweis zur verantwortlichen Stelle</h3>
            <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
            <p>
              Serdar Dogan<br />
              Dogan Immobilien<br />
              Billtalstraße 32<br />
              65929 Frankfurt am Main<br /><br />
              Telefon: +49 175 6900374<br />
              E-Mail: serdar.dogan@immobilien-dogan.com
            </p>
            <p>
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
              gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
              personenbezogenen Daten entscheidet.
            </p>

            <h3>Speicherdauer</h3>
            <p>
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt
              wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die
              Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen
              oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht,
              sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
              personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
              Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall
              dieser Gründe.
            </p>

            <h3>Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung</h3>
            <p>
              Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
              personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO. Sind Ihre
              Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich, verarbeiten wir Ihre Daten auf Grundlage von Art. 6 Abs. 1 lit. b
              DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer
              rechtlichen Verpflichtung erforderlich sind, auf Grundlage von Art. 6 Abs. 1 lit. c
              DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses
              nach Art. 6 Abs. 1 lit. f DSGVO erfolgen.
            </p>

            <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p>
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung
              möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die
              Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
              unberührt.
            </p>

            <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
            <p>
              Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei
              einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen
              Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu.
            </p>

            <h3>SSL- bzw. TLS-Verschlüsselung</h3>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
              Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen
              Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt
              und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
          </section>

          {/* 4 */}
          <section>
            <h2>4. Datenerfassung auf dieser Website</h2>

            <h3>Cookies</h3>
            <p>
              Unsere Website verwendet Cookies. Das sind kleine Datenpakete, die auf Ihrem Endgerät
              gespeichert werden. Wir nutzen Cookies ausschließlich für technisch notwendige
              Funktionen wie die Speicherung Ihrer Cookie-Einstellungen (localStorage). Es werden
              keine Analyse- oder Marketing-Cookies ohne Ihre Einwilligung gesetzt.
            </p>
            <p>
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies
              informiert werden und Cookies nur im Einzelfall erlauben.
            </p>

            <h3>Kontaktformulare</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
              dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
              Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p>
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
              sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur
              Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen
              beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven
              Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
            </p>

            <h3>Anfrage per E-Mail oder Telefon</h3>
            <p>
              Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller
              daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der
              Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben
              wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p>
              Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
              (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
              effektiver Bearbeitung).
            </p>

            <h3>Kommunikation via WhatsApp</h3>
            <p>
              Zur Kommunikation mit unseren Kunden und Interessenten nutzen wir den Dienst WhatsApp
              der WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2,
              Irland. Die Kommunikation erfolgt über eine Ende-zu-Ende-Verschlüsselung. Bitte
              beachten Sie, dass WhatsApp Metadaten (z. B. Zeitpunkt der Kommunikation,
              Telefonnummern) verarbeitet und diese an die Muttergesellschaft Meta Platforms Inc.
              in die USA übermitteln kann. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
              (Vertragsanbahnung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
              einer effizienten Kundenkommunikation). Wenn Sie nicht möchten, dass Ihre Daten über
              WhatsApp verarbeitet werden, kontaktieren Sie uns bitte per E-Mail oder Telefon.
            </p>
          </section>

          {/* 5 */}
          <section>
            <h2>5. Ihre Rechte</h2>
            <p>Sie haben jederzeit das Recht:</p>
            <ul>
              <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten</li>
              <li>Die Berichtigung unrichtiger personenbezogener Daten zu verlangen</li>
              <li>Die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
              <li>Die Einschränkung der Datenverarbeitung zu verlangen</li>
              <li>Der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen</li>
              <li>Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten</li>
            </ul>
            <p>
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an
              uns wenden.
            </p>
          </section>

          {/* 6 */}
          <section>
            <h2>6. Plugins und Tools</h2>

            <h3>Google Fonts</h3>
            <p>
              Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google
              Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser
              die benötigten Fonts in ihren Browsercache. Zu diesem Zweck muss der von Ihnen
              verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt
              Google Kenntnis darüber, dass über Ihre IP-Adresse diese Website aufgerufen wurde.
            </p>
            <p>
              Die Nutzung von Google Fonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
              (berechtigtes Interesse an einheitlicher Schriftdarstellung). Weitere Informationen:{' '}
              <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">
                https://developers.google.com/fonts/faq
              </a>{' '}
              sowie{' '}
              <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">
                https://policies.google.com/privacy?hl=de
              </a>.
            </p>

            <h3>HubSpot CRM</h3>
            <p>
              Diese Website nutzt HubSpot CRM, einen Dienst der HubSpot, Inc., 25 First Street,
              2nd Floor, Cambridge, MA 02141, USA. HubSpot wird eingesetzt, um Kontaktanfragen zu
              verwalten und Interessenten zu betreuen. Beim Absenden eines Formulars auf dieser
              Website werden die eingegebenen Daten (z. B. Name, E-Mail-Adresse, Telefonnummer,
              Anliegen) an HubSpot übermittelt und dort gespeichert. Unser HubSpot-Portal ist in
              der EU-Region gehostet. Mit HubSpot wurde ein Auftragsverarbeitungsvertrag gemäß
              Art. 28 DSGVO abgeschlossen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
              (Vertragsanbahnung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
              effizientem Leadmanagement). Weitere Informationen:{' '}
              <a href="https://legal.hubspot.com/de/privacy-policy" target="_blank" rel="noopener noreferrer">
                https://legal.hubspot.com/de/privacy-policy
              </a>
            </p>
          </section>

          {/* 7 */}
          <section>
            <h2>7. Änderungen dieser Datenschutzerklärung</h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den
              aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen
              umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
            </p>
          </section>

          <p className="text-sm text-[#c8c6c4]/60 mt-12">
            Quelle:{' '}
            <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer">
              e-recht24.de
            </a>
          </p>

        </div>
      </div>
    </div>
  );
}
